<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1080 1920"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="fill-rule: evenodd; clip-rule: evenodd; stroke-miterlimit: 10"
  >
    <g id="Layer-1" serif:id="Layer 1" transform="matrix(0.5,0,0,0.5,0,0)">
      <g id="background">
        <g transform="matrix(2,-0,-0,2,0,0)">
          <image
            href="../assets/background.jpg"
            x="0"
            y="1"
            width="1080px"
            height="1919px"
          />
        </g>
      </g>
      <g id="scorebackground">
        <g transform="matrix(1,0,0,1,880,197)">
          <path
            d="M0,384L-734.119,384C-744.383,384 -752.703,375.679 -752.703,365.415L-752.703,18.585C-752.703,8.321 -744.383,0 -734.119,0L0,0C10.264,0 18.585,8.321 18.585,18.585L18.585,365.415C18.585,375.679 10.264,384 0,384"
            style="fill: rgb(254, 254, 254); fill-rule: nonzero"
          />
        </g>
      </g>
      <g id="timebackground">
        <g transform="matrix(1,0,0,1,2007.13,197)">
          <path
            d="M0,384L-734.119,384C-744.383,384 -752.703,375.679 -752.703,365.415L-752.703,18.585C-752.703,8.321 -744.383,0 -734.119,0L0,0C10.264,0 18.585,8.321 18.585,18.585L18.585,365.415C18.585,375.679 10.264,384 0,384"
            style="fill: rgb(254, 254, 254); fill-rule: nonzero"
          />
        </g>
      </g>
      <g id="score" transform="matrix(2,0,0,2,-508.247,-320.562)">
        <g transform="matrix(116.5,0,0,116.5,803.264,396.789)"></g>
        <text
          x="660px"
          y="396.789px"
          style="
            font-family: 'Inter', 'Open Sans', sans-serif;
            font-weight: 600;
            font-size: 116.5px;
            fill: rgb(22, 38, 78);
          "
          text-anchor="end"
        >
          {{ score }}
        </text>
      </g>
      <g id="time" transform="matrix(2,0,0,2,303.288,-320.562)">
        <g transform="matrix(116.5,0,0,116.5,817.57,396.789)"></g>
        <text
          x="510px"
          y="396.789px"
          style="
            font-family: 'Inter', 'Open Sans', sans-serif;
            font-weight: 600;
            font-size: 116.5px;
            fill: rgb(22, 38, 78);
          "
        >
          00:{{ timeLeftFormatted }}
        </text>
      </g>
      <g id="Fields" transform="matrix(1,0,0,1,-2.5,18.688)">
        <g opacity="0.5">
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-2012.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-1572.39)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-1132.48)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-692.391)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,-252.479)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,536.064,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,856.056,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1176.05,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1496.04,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,1816.03,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
          <g transform="matrix(-0.98485,0,0,0.983607,2136.03,187.609)">
            <rect
              x="105.138"
              y="2738.69"
              width="304.615"
              height="427"
              style="fill: white"
            />
          </g>
        </g>
      </g>
      <g :transform="posFieldTransform()">
        <g
          v-if="gameActive"
          @click="posFieldClicked"
          id="posField"
          transform="matrix(0.98485,0,0,0.983607,-617.24,-403.913)"
        >
          <g transform="matrix(-1,0,0,1,1822.12,-1168.38)">
            <rect
              x="758.754"
              y="2290.69"
              width="304.615"
              height="427"
              style="fill: rgb(242, 115, 131)"
            />
          </g>
          <g transform="matrix(0.9,0,0,0.9,776.058,1200.81)">
            <image
              href="../assets/correct.svg"
              x="0"
              y="0"
              width="300"
              height="300"
              preserveAspectRatio="xMidYMid meet"
            />
          </g>
        </g>
      </g>
      <g :transform="negFieldTransform()">
        <g
          v-if="gameActive"
          @click="negFieldClicked"
          id="negField"
          transform="matrix(0.98485,0,0,0.983607,-1256.5,-1725.88)"
        >
          <g transform="matrix(-1,0,0,1,3120.31,1519.62)">
            <rect
              x="1407.85"
              y="946.688"
              width="304.615"
              height="427"
              style="fill: rgb(254, 187, 41)"
            />
          </g>
          <g transform="matrix(0.9,0,0,0.9,1425.153,2544.808)">
            <image
              href="../assets/wrong.svg"
              x="0"
              y="0"
              width="300"
              height="300"
              preserveAspectRatio="xMidYMid meet"
            />
          </g>
        </g>
      </g>
      <g id="StartModal" v-if="!gameActive">
        <g transform="matrix(2,0,0,2,-9720,0)">
          <rect
            x="4860"
            y="0"
            width="1080"
            height="1920"
            style="fill-opacity: 0.5"
          />
        </g>
        <g
          id="StartBtn"
          transform="matrix(1.00072,0,0,1.00072,0.56421,-877.615)"
          @click="startGame()"
        >
          <g transform="matrix(1,0,0,1,1969.42,2536.78)">
            <rect
              x="-1798.27"
              y="0"
              width="1815.002"
              height="258.817"
              rx="50"
              ry="50"
              style="
                fill: rgb(145, 202, 238);
                fill-rule: nonzero;
                filter: url(#dropShadow);
              "
            />
          </g>
          <g transform="matrix(1.00052,0,0,1.00052,-409.118,-1.36457)">
            <g transform="matrix(129.135,0,0,129.135,1847.61,2712.17)"></g>
            <text
              x="1490px"
              y="2712.17px"
              text-anchor="middle"
              style="
                font-family: 'Inter', 'Open Sans', sans-serif;
                font-weight: 800;
                font-size: 120px;
                fill: rgb(22, 38, 78);
              "
            >
              Start het spel!
            </text>
          </g>
        </g>
      </g>
    </g>
    <g id="Layer-2" serif:id="Layer 2"></g>
    <defs>
      <filter id="dropShadow">
        <feOffset dx="0" dy="30" result="offsetblur" />
        <feGaussianBlur in="offsetblur" stdDeviation="6" result="outputblur" />
        <feFlood flood-color="rgba(0,0,0,0.2)" result="offsetblur" />
        <feComposite
          in="offsetblur"
          in2="outputblur"
          operator="in"
          result="offsetblur"
        />
        <feMerge>
          <feMergeNode in="offsetblur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <image
        id="_Image2"
        width="386px"
        height="193px"
        xlink:href="data:image/png;base64,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"
      />
      <image
        id="_Image3"
        width="402px"
        height="209px"
        xlink:href="data:image/png;base64,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"
      />
      <image
        id="_Image4"
        width="386px"
        height="193px"
        xlink:href="data:image/png;base64,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"
      />
      <image
        id="_Image5"
        width="402px"
        height="209px"
        xlink:href="data:image/png;base64,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"
      />
      <linearGradient
        id="_Linear6"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(56.9544,0,0,45.4005,117.39,58.8203)"
      >
        <stop offset="0" style="stop-color: white; stop-opacity: 0" />
        <stop offset="0.5" style="stop-color: white; stop-opacity: 0.3" />
        <stop offset="1" style="stop-color: white; stop-opacity: 0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "GameScreen",
  data() {
    return {
      gameTime: 20, // Total time for the game
      gameTimeLeft: 20, // Countdown time in seconds
      score: 0,
      posActiveField: 0,
      negActiveField: 0,
      isRunning: false, // Track if the timer is running
      timer: null, // Reference to the interval timer
      posFieldTimer: null, // Timer for the posField countdown
      posFieldTime: 100, // Countdown time for positive field in milliseconds
      gameActive: false,
      fieldsRange: 36,
      fieldArray: [
        { x: 0, y: 0 },
        { x: 160, y: 0 },
        { x: 320, y: 0 },
        { x: 480, y: 0 },
        { x: 640, y: 0 },
        { x: 800, y: 0 },
        { x: 0, y: 220 },
        { x: 160, y: 220 },
        { x: 320, y: 220 },
        { x: 480, y: 220 },
        { x: 640, y: 220 },
        { x: 800, y: 220 },
        { x: 0, y: 440 },
        { x: 160, y: 440 },
        { x: 320, y: 440 },
        { x: 480, y: 440 },
        { x: 640, y: 440 },
        { x: 800, y: 440 },
        { x: 0, y: 660 },
        { x: 160, y: 660 },
        { x: 320, y: 660 },
        { x: 480, y: 660 },
        { x: 640, y: 660 },
        { x: 800, y: 660 },
        { x: 0, y: 880 },
        { x: 160, y: 880 },
        { x: 320, y: 880 },
        { x: 480, y: 880 },
        { x: 640, y: 880 },
        { x: 800, y: 880 },
        { x: 0, y: 1100 },
        { x: 160, y: 1100 },
        { x: 320, y: 1100 },
        { x: 480, y: 1100 },
        { x: 640, y: 1100 },
        { x: 800, y: 1100 },
      ],
    };
  },
  created() {
    this.assignActiveFields();
  },
  computed: {
    timeLeftFormatted() {
      return this.gameTimeLeft.toString().padStart(2, "0");
    },
    batteryHeight() {
      const maxHeight = 0.223; // Maximum height at 100%
      return (this.score / 750) * maxHeight;
    },
    yPosition() {
      const maxHeight = 0.223;
      return -0.112 + (maxHeight - this.batteryHeight);
    },
  },
  methods: {
    startGame() {
      this.assignActiveFields();
      this.startTimer();
      this.gameActive = true;
    },
    posFieldClicked() {
      if (this.gameActive) {
        console.log(this.posFieldTime);
        this.score += Math.round(this.posFieldTime / 2); // Add remaining posFieldTime to score
        this.score += 2; // Base score for positive field click
        // this.score += this.posFieldTime;
        this.resetPosFieldTimer(); // Reset the positive field timer
        this.assignActiveFields();
      }
    },
    negFieldClicked() {
      if (this.gameActive) {
        this.score -= 1;
        this.assignActiveFields();
      }
    },
    negFieldTransform() {
      const { x, y } = this.fieldArray[this.negActiveField - 1];
      return `translate(${x * 2}, ${y * 2})`;
    },
    posFieldTransform() {
      const { x, y } = this.fieldArray[this.posActiveField - 1];
      return `translate(${x * 2}, ${y * 2})`;
    },
    assignActiveFields() {
      this.posActiveField = this.getRandomNumber(
        this.fieldsRange,
        this.posActiveField,
        this.negActiveField
      );

      this.negActiveField = this.getRandomNumber(
        this.fieldsRange,
        this.posActiveField,
        this.negActiveField
      );

      this.resetPosFieldTimer(); // Reset the timer whenever a new posField is assigned
    },
    getRandomNumber(range, ...exclusions) {
      let randomNum;
      do {
        randomNum = Math.floor(Math.random() * range) + 1;
      } while (exclusions.includes(randomNum));
      return randomNum;
    },
    resetPosFieldTimer() {
      clearInterval(this.posFieldTimer); // Clear the old timer
      this.posFieldTime = 200; // Reset to 100 milliseconds
      // console.log("Timer reset to:", this.posFieldTime); // Log reset time
      this.posFieldTimer = setInterval(() => {
        if (this.posFieldTime > 0) {
          this.posFieldTime--;
          // console.log("PosFieldTime:", this.posFieldTime); // Log countdown
        } else {
          clearInterval(this.posFieldTimer); // Stop when it reaches 0
        }
      }, 1);
    },
    startTimer() {
      if (this.isRunning) return;
      this.isRunning = true;
      this.timer = setInterval(() => {
        if (this.gameTimeLeft > 0) {
          this.gameTimeLeft--;
        } else {
          this.endTimer();
        }
      }, 1000);
    },
    endTimer() {
      clearInterval(this.timer);
      clearInterval(this.posFieldTimer); // Stop the posField timer
      this.isRunning = false;
      this.onTimerEnd();
    },
    resetTimer() {
      clearInterval(this.timer);
      clearInterval(this.posFieldTimer); // Clear the posField timer
      this.isRunning = false;
      this.gameTimeLeft = this.gameTime;
    },
    onTimerEnd() {
      this.gameActive = false;
      this.$store.commit("setScore", this.score);
      this.$store.dispatch("updatePlayer");
      this.$store.commit("setPlayerState", "end");
    },
  },
  beforeUnmount() {
    clearInterval(this.timer);
    clearInterval(this.posFieldTimer); // Clean up posField timer
  },
};
</script>

<style></style>
